import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {
  accountingDocumentFormValuesSchema,
  accountingInvoiceItemWithMandatoryFields,
  accountingPaymentInfo,
} from '../../../types';

export const createIncomeCashReceiptSchema = accountingDocumentFormValuesSchema
  .required({paymentType: true})
  .extend({
    issueDate: z.string(),
    cashRegisterId: z.string(),
    paymentInfo: accountingPaymentInfo.pick({variableSymbol: true}).extend({
      paymentMethod: z.enum(['CARD', 'CASH']),
    }),
    invoiceItems: z.array(accountingInvoiceItemWithMandatoryFields),
  })
  .superRefine((data, ctx) => {
    if (data.isExchangeRateRatioEnabled && isNil(data.exchangeRateRatio?.ratio)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['exchangeRateRatio', 'ratio'],
      });
    }
  });
